import { Button } from '@/common'
import useI18n from '@/shared/hooks/usei18n'
import { useLogout } from '@/features/auth/hooks/auth'
import AuthLayout from '../../components/AuthLayout'

export default function OrganizationDeactivatedPage() {
  const { t } = useI18n()
  const { mutateAsync: logout } = useLogout()

  return (
    <AuthLayout showCarousel={false}>
      <div className="flex flex-col items-center space-y-4 p-6">
        <div className="text-center space-y-3">
          <h2 className="text-xl font-semibold">{t('common:organization.deactivated.title')}</h2>
          <p className="text-text-secondary text-sm whitespace-pre-line">
            {t('common:organization.deactivated.body')}
            <br />
            <a
              href={`mailto:${t('common:organization.deactivated.contact')}`}
              className="text-green-600 underline break-all"
            >
              {t('common:organization.deactivated.contact')}
            </a>
          </p>
        </div>
        <div className="text-sm px-10 text-center pt-4">
          <Button type="button" variant="subtle" sizeType="sm" onClick={() => logout()}>
            {t('common:navbar.userMenu.logout')}
          </Button>
        </div>
      </div>
    </AuthLayout>
  )
}
